import { ReactNode } from 'react';

interface SectionEyebrowProps {
  children: ReactNode;
  /** Set on the ink bands, where the paper-side hairline has no contrast. */
  invert?: boolean;
  className?: string;
}

/** Title-case category label in a bordered pill, above a section headline. */
export function SectionEyebrow({ children, invert = false, className = '' }: SectionEyebrowProps) {
  return (
    <p className={`bc-eyebrow ${invert ? 'bc-eyebrow-invert' : ''} ${className}`.trim()}>
      {children}
    </p>
  );
}
